import * as _ from 'lodash';

import * as types from './types';
import { SchoolCalendarFieldEnum as Fields } from 'Common/FieldEnum';
import { getFiscalYear, defaultDateFormat } from 'Common/GeneralHelper';

const INITIAL_STATE = {
  fetching: false,
  fetched: false,
  fetchError: null,
  data: {
    [Fields.Description]: '',
    [Fields.FirstDayDT]: null,
    [Fields.LastDayDT]: null,
    [Fields.MbeEnabled]: false,
    [Fields.FiscalYear]: getFiscalYear(new Date()),
    [Fields.MbeOperationalDays]: null,
    [Fields.GracePeriodCalendarDays]: null,
    [Fields.CepTransferOperationalDays]: null,
    [Fields.SchoolCalendarExceptions]: [],
    [Fields.SchoolCalendarSiteMasters]: [],
  },
  initialData: {
    [Fields.SchoolCalendarExceptions]: [],
    [Fields.SchoolCalendarSiteMasters]: [],
  },
  submitting: false,
  submitted: false,
  submitError: null,
  deleting: false,
  deleted: false,
  deleteError: null,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.SCHOOL_CALENDAR_FETCHING:
      return {
        ...state,
        fetching: payload,
        fetched: payload ? false : state.fetched,
      };

    case types.SCHOOL_CALENDAR_FETCH: {
      const { calendar, isNew } = payload;

      calendar[Fields.SchoolCalendarSiteMasters] = calendar[
        Fields.SchoolCalendarSiteMasters
      ].map(assignment => ({
        ...assignment,
        [Fields.Assigned]: isNew ? false : assignment[Fields.Assigned],
      }));

      const nextData = isNew
        ? {
            ...calendar,
            [Fields.Description]: '',
            [Fields.SchoolCalendarSiteMasters]: [],
          }
        : {
            ...calendar,
            [Fields.SchoolCalendarExceptions]: calendar[
              Fields.SchoolCalendarExceptions
            ].map(exception => ({
              ...exception,
              [Fields.BeginDay]: defaultDateFormat(exception[Fields.BeginDay]),
              [Fields.EndDay]: defaultDateFormat(exception[Fields.EndDay]),
            })),
          };

      nextData[Fields.FirstDayDT] = defaultDateFormat(
        calendar[Fields.FirstDayDT]
      );
      nextData[Fields.LastDayDT] = defaultDateFormat(
        calendar[Fields.LastDayDT]
      );
      nextData[Fields.MealExpirationDT] = calendar[Fields.MealExpirationDT]
        ? defaultDateFormat(calendar[Fields.MealExpirationDT])
        : null;

      nextData[Fields.SchoolCalendarSiteMasters] =
        calendar[Fields.SchoolCalendarSiteMasters];

      return {
        ...state,
        data: nextData,
        initialData: _.cloneDeep(nextData),
        fetched: true,
      };
    }

    case types.SCHOOL_CALENDAR_FETCH_ERROR:
      if (_.has(payload, 'response.data')) {
        const fetchError = payload.response.data.Errors[0];

        return {
          ...state,
          fetchError,
        };
      }

      return {
        ...state,
        fetchError: {
          Title: 'Error',
          Message:
            'An error occurred while fetching this School Calendar. Please try again',
        },
      };

    case types.SCHOOL_CALENDAR_SUBMITTING:
      return {
        ...state,
        submitting: payload,
      };

    case types.SCHOOL_CALENDAR_SUBMIT:
      return {
        ...state,
        submitted: true,
      };

    case types.SCHOOL_CALENDAR_SUBMIT_ERROR:
      if (_.has(payload, 'response.data')) {
        const submitError = payload.response.data.Errors[0];

        return {
          ...state,
          submitError,
        };
      }

      return {
        ...state,
        submitError: {
          Title: 'Error',
          Message:
            'An error occurred while saving this School Calendar. Please try again',
        },
      };

    case types.SCHOOL_CALENDAR_DELETING:
      return {
        ...state,
        deleting: payload,
      };

    case types.SCHOOL_CALENDAR_DELETE:
      return {
        ...state,
        deleted: true,
      };

    case types.SCHOOL_CALENDAR_DELETE_ERROR:
      if (_.has(payload, 'response.data')) {
        const deleteError = payload.response.data.Errors[0];

        return {
          ...state,
          deleteError,
        };
      }

      return {
        ...state,
        deleteError: {
          Title: 'Error',
          Message:
            'An error occurred while deleting this School Calendar. Please try again',
        },
      };

    case types.SCHOOL_CALENDAR_CLEAR_ERROR_SUCCESS:
      return {
        ...state,
        submitted: false,
        submitError: null,
        fetchError: null,
        deleted: false,
        deleteError: null,
      };

    case types.SCHOOL_CALENDAR_ADD_EXCEPTION:
      return {
        ...state,
        data: {
          ...state.data,
          [Fields.SchoolCalendarExceptions]: [
            ...state.data[Fields.SchoolCalendarExceptions],
            payload,
          ],
        },
      };

    case types.SCHOOL_CALENDAR_REMOVE_EXCEPTION:
      return {
        ...state,
        data: {
          ...state.data,
          [Fields.SchoolCalendarExceptions]: state.data[
            Fields.SchoolCalendarExceptions
          ].filter((e, i) => i !== payload),
        },
      };

    case types.SCHOOL_CALENDAR_EDIT_EXCEPTION:
      return {
        ...state,
        data: {
          ...state.data,
          [Fields.SchoolCalendarExceptions]: state.data[
            Fields.SchoolCalendarExceptions
          ].map((e, i) => (i === payload.index ? payload.exception : e)),
        },
      };

    case types.SCHOOL_CALENDAR_TOGGLE_ASSIGNMENT:
      return {
        ...state,
        data: {
          ...state.data,
          [Fields.SchoolCalendarSiteMasters]: state.data[
            Fields.SchoolCalendarSiteMasters
          ].map((assignment, i) => {
            return payload === i
              ? {
                  ...assignment,
                  [Fields.Assigned]: !assignment[Fields.Assigned],
                }
              : assignment;
          }),
        },
      };

    case types.SCHOOL_CALENDAR_TOGGLE_ALL_ASSIGNMENTS: {
      const indexes = payload.map(r => r._index);
      const checked = payload.every(r => r._original[Fields.Assigned]);

      return {
        ...state,
        data: {
          ...state.data,
          [Fields.SchoolCalendarSiteMasters]: state.data[
            Fields.SchoolCalendarSiteMasters
          ].map((assignment, i) => {
            return indexes.includes(i)
              ? { ...assignment, [Fields.Assigned]: !checked }
              : assignment;
          }),
        },
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/schoolcalendar/state/calendar/reducer.js